import React, { Component } from 'react';
import { MapPin } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { WA_NUMBER } from '../data/products';
export function HeroSection() {
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Vi la oferta 20% OFF y quiero pedir mis suplementos')}`;
  return <section className="relative pt-[100px] px-5 pb-[100px] text-center overflow-hidden" data-id="element-157">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-158">
        <img src="https://cdn.magicpatterns.com/uploads/4tU7iMx3XJesMuSvHEn9z9/WhatsApp_Image_2026-04-17_at_12.35.55_PM.jpg" alt="" className="w-full h-full object-cover object-top sm:object-center" data-id="element-159" />
        {/* Dark overlay — strong enough for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90" data-id="element-160" />
        {/* Gold tint overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a1500]/40 via-transparent to-[#1a1500]/40" data-id="element-161" />
      </div>

      <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-162">
        <div className="inline-flex items-center gap-1.5 bg-alphaGold text-white text-[0.8rem] font-extrabold tracking-[3px] py-1.5 px-4 rounded-sm uppercase mb-8" data-id="element-163">
          <MapPin className="w-3.5 h-3.5" data-id="element-164" /> Montevideo · Suplementos Deportivos
        </div>

        <h1 className="text-[clamp(2.2rem,6vw,4.2rem)] font-black leading-[1.1] uppercase tracking-[2px] mb-8 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-165">
          Para de <span className="text-alphaGold" data-id="element-166">Perder el Tiempo</span>
          <br data-id="element-167" />
          y Empieza a Ver
          <br data-id="element-168" />
          <span className="text-alphaGold" data-id="element-169">Resultados Reales</span>
        </h1>

        <p className="text-[clamp(1rem,2.5vw,1.3rem)] text-[#ddd] max-w-[720px] mx-auto mb-[50px] leading-[1.7] drop-shadow-[0_1px_6px_rgba(0,0,0,0.8)]" data-id="element-170">
          Dejá de entrenar horas y no ver cambios. Los suplementos correctos —
          al precio correcto — marcan la diferencia que tu cuerpo necesita.{' '}
          <strong className="text-white" data-id="element-171">Hoy con 20% OFF.</strong>
        </p>

        <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 bg-whatsapp text-white text-[1.1rem] font-extrabold py-[18px] px-10 rounded uppercase tracking-[1px] transition-all duration-200 shadow-[0_6px_30px_rgba(37,211,102,0.35)] hover:-translate-y-[3px] hover:shadow-[0_10px_40px_rgba(37,211,102,0.5)]" data-id="element-172">
          <WhatsAppIcon className="w-[22px] h-[22px]" data-id="element-173" />
          Pedir por WhatsApp Ahora
        </a>
      </div>
    </section>;
}